import Model from './Model'
export default class Role extends Model {

    resource()
    {
        return 'roles'
    }

    get protectedRoles() {
        return [
            1,
            2,
            3,
            4,
            5,
            6
        ]
    }
}
